// ABOUTME: RTK Query endpoints for backend-initiated OAuth code exchanges that need
// ABOUTME: the shared Authorization header (unlike the raw-fetch amazon oauth calls).
import { apiSlice } from "../createApiSlice";

const oauthSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        exchangeTikTokCode: builder.mutation({
            query: ({ code }) => ({
                url: `/oauth/tiktok/exchange`,
                method: 'POST',
                body: { code },
            }),
        }),
    })
});

export const {
    useExchangeTikTokCodeMutation,
} = oauthSlice;
